/**
 * @fileoverview Agent definition for split-point-detector-v1.
 *
 * Detects the optimal split point in a chapter's prose content.
 * Output is used by the heuristic HTML splitter — no metadata generation.
 *
 * @category narrative.chapters.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'split-point-detector-v1',
  kind: 'primitive',
  name: 'Split Point Detector',
  description: 'Detects the optimal split point in a chapter with written content.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.chapters.operations',
    usedBy: [
      'primitives/use-split-point-detector-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-splitter-v2',
      'chapter-rebuilder-v1',
    ],
  },
};
